module.exports = __webpack_public_path__ + "static/media/Flaticon.35d544ea.eot";